




















































import Picture from '@/pages/profile/blocks/cards/components/picture/Picture.vue';
// TODO: надо вообще всю карточку на фиг переделывать, это жесть, в особенности убрать зависимость от другого модуля
import Message from '@/pages/profile/blocks/cards/purchases/components/message/Message.vue';
import Cancellation from '@/pages/profile/blocks/cards/purchases/components/cancellation/Cancellation.vue';
import { routeParse } from '@/pages/profile/utils';
import { OrderStatusConfig } from '@/pages/profile/views/purchases/types';

export default {
  name: 'PurchaseActivityCard',

  components: {
    Picture,
    Message,
    Cancellation,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpenComment: false,
    };
  },

  computed: {
    orderStatusConfig() {
      return OrderStatusConfig;
    },
  },

  methods: {
    hide() {
      this.$emit('hide');
    },

    routerActivity(val) {
      const id = val.activity_id;
      const name = 'activity';
      return routeParse(id, '', name);
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/purchaseActivityCard/purchaseActivityCard.vue